import React, {useEffect, useState} from "react";
import './classes.scss';
import CourseHeader from "../../../shared/components/AppHeader";
import ClassCards from "../../../shared/components/CourseComponents/ClassCards";
import ClassForm from "../../../shared/components/CourseComponents/ClassForm";
import ClassroomService from "../../../services/CourseServices/ClassroomService/classroom.service";
import {withRouter} from "react-router-dom";
import PaginationComponent from "../../../shared/components/PaginationComponent";
import EmptyState from "../../../shared/components/EmptyState";

const Classes = (props: any) => {

    const {boardId} = props.match?.params;

    useEffect(()=>{
        fetchClassrooms(1)
    },[])

    const [classes,setClasses] = useState<any>([]);
    const [formVisible,setFormVisible] = useState<boolean>(false);
    const [paginationMeta,setPaginationMeta] = useState<any>();
    const [currentPageNumber,setCurrentPageNumber] = useState<number>(1);

    const fetchClassrooms = (pageNumber:number,searchString?:string) => {

        let queryParams = `?page=${pageNumber}&board_id=${boardId}&search=${searchString || ''}`

        ClassroomService.getClassroomsList(queryParams,
            (classrooms:any,pageMeta:any)=>{
                setClasses([...classrooms])
                setPaginationMeta(pageMeta)
            },
            ()=>{},
            ()=>{},
        ).then()
    }

    const handleSearch = (value:string) => {
        fetchClassrooms(currentPageNumber,value)
    }

    const handleNewBoard = () => {
        setFormVisible(true)
    }

    const handlePageChange = (page:number) => {
        fetchClassrooms(page);
        setCurrentPageNumber(page);
    }

    return (
        <div className='page-view'>
            <ClassForm title='Create New Class'
                       visible={formVisible}
                       setVisible={setFormVisible}
                       refreshList={fetchClassrooms}
                       currentPageNumber={currentPageNumber}
                       boardId={boardId}
            />
            <CourseHeader headerText='Class'
                          handleSearch={handleSearch}
                          handleHeaderAction={handleNewBoard}
                          buttonText='Class'
                          showBreadCrumb={true}
            />
            {classes.length !== 0 ?
                <>
                    <ClassCards classes={classes}
                                refreshList={fetchClassrooms}
                                currentPageNumber={currentPageNumber}
                    />
                    <PaginationComponent handlePageChange={handlePageChange}
                                         paginationMeta={paginationMeta}
                    />
                </>
                :
                <EmptyState text={'No classes found.'}/>
            }
        </div>
    )
}

export default withRouter(Classes);
